import React, { Component } from 'react';
import { withTranslation, Translation, } from 'react-i18next';

import {BrowserView,MobileView,TabletView, isMobileOnly, isTablet} from 'react-device-detect';

import { View, ActivityIndicator} from "react-native-web";

/*import HeaderPC from '../../header/HeaderPC';
import HeaderMobile from '../../header/HeaderMobile';
import HeaderTablet from '../../header/HeaderTablet';*/

const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;

export default function LoadingPage() {




    return (

	         <div>


                   {!isMobileOnly && !isTablet &&
                     <BrowserView>

                       <View style={{width:viewportWidth, height: viewportHeight, position: 'relative', justifyContent: 'center', alignSelf: 'center'}}>




                          <div style={{fontFamily: 'Roboto',fontSize: '50px', color: '#fff', textAlign: 'center', textShadow: '1px 1px 2px black'}}>
                             <img src={'https://s3.us-east-1.amazonaws.com/debyooinc20.img/yeqola/yeqola_logo_horiz_gradient_min.png'} alt="Yeqola Logo" style={{height: '150px'}}/>
                          </div>

                          <div style={{clear: 'both', height: '40px'}}/>

                         <ActivityIndicator  animating={true} color="#5800d9" />
                       </View>
                    </BrowserView>
                  }



                  {isMobileOnly &&
                   <MobileView>
                     <View style={{width:viewportWidth, height: viewportHeight, position: 'relative', justifyContent: 'center', alignSelf: 'center'}}>





                      <div style={{fontFamily: 'Roboto',fontSize: '30px', color: '#fff', textAlign: 'center', textShadow: '1px 1px 2px black'}}>
                       <img src={'https://s3.us-east-1.amazonaws.com/debyooinc20.img/yeqola/yeqola_logo_horiz_gradient_min.png'} alt="Yeqola Logo" style={{width: '200px'}}/>
                      </div>

                      <div style={{clear: 'both', height: '40px'}}/>



                       <ActivityIndicator  animating={true} color="#5800d9" />
                     </View>
                  </MobileView>
                 }

                 {isTablet &&
                   <TabletView>
                       <View style={{width:viewportWidth, height: viewportHeight, position: 'relative', justifyContent: 'center', alignSelf: 'center'}}>




                        <div style={{fontFamily: 'Roboto',fontSize: '50px', color: '#fff', textAlign: 'center', textShadow: '1px 1px 2px black'}}>
                           <img src={'https://s3.us-east-1.amazonaws.com/debyooinc20.img/yeqola/yeqola_logo_horiz_gradient_min.png'} alt="Yeqola Logo" style={{height: '150px'}}/>
                        </div>

                        <div style={{clear: 'both', height: '40px'}}/>



                         <ActivityIndicator  animating={true} color="#5800d9" />



                       </View>
                   </TabletView>
                 }



	        </div>

    )

}
